import AmplitudeEvent from './AmplitudeEvent'
import { getPageName } from './utils'

// =============================================================================
// Abstract base class for all account events
// =============================================================================

abstract class AccountAmplitudeEvent extends AmplitudeEvent {
  category = 'account'
}

// =============================================================================
// Account events (for descriptions, see the Notion doc)
// =============================================================================

export class ClickConnectWalletEvent extends AccountAmplitudeEvent {
  name = 'click connect wallet'

  constructor(path: string) {
    super()
    this.properties = {
      page: getPageName(path),
    }
  }
}

export class ConnectWalletEvent extends AccountAmplitudeEvent {
  name = 'connect wallet'
}

export class DisconnectWalletEvent extends AccountAmplitudeEvent {
  name = 'disconnect wallet'
}

export class OpenNotificationsFeedEvent extends AccountAmplitudeEvent {
  name = 'open notifications feed'
}

export class ClickNotificationItemEvent extends AccountAmplitudeEvent {
  name = 'click notification item'
}

export class OpenAccountDropdownEvent extends AccountAmplitudeEvent {
  name = 'open account dropdown'
}

export class CloseAccountDropdownEvent extends AccountAmplitudeEvent {
  name = 'close account dropdown'
}
